import { AlertCircleIcon, CheckCircle2Icon } from 'lucide-react'

import { CASE_INQUIRY_ICON_TYPE_MAP, type CaseInquiryIconType } from '@/lib/queries/types'
import { cn } from '@/lib/utils'

export interface CaseProcessingTimeStatusTextProps {
  statusIconType?: CaseInquiryIconType
  statusText?: string
  classNames?: string
}

export const CaseProcessingTimeStatusText = ({
  statusIconType = CASE_INQUIRY_ICON_TYPE_MAP.checkMark,
  statusText,
  classNames,
}: CaseProcessingTimeStatusTextProps) => {
  return (
    <p
      className={cn(
        'flex gap-2.5',
        'text-sm font-semibold leading-6',
        {
          'text-primary': statusIconType === CASE_INQUIRY_ICON_TYPE_MAP.checkMark,
          'text-pink-500': statusIconType === CASE_INQUIRY_ICON_TYPE_MAP.exclamationMark,
        },
        classNames
      )}
    >
      {statusIconType === CASE_INQUIRY_ICON_TYPE_MAP.checkMark && <CheckCircle2Icon size={24} />}
      {statusIconType === CASE_INQUIRY_ICON_TYPE_MAP.exclamationMark && <AlertCircleIcon size={24} />}
      {statusText}
    </p>
  )
}
